import React, {useEffect, useState} from 'react';
import {SortableList} from "../../SortableList/SortableList";
import {AddModal} from "./AddModal";
import {Modal} from "../../General/Modal/Modal";
import {AddButton} from "../../General/AddButton";

export const Preset = ({preset, setPreset, doDelete, addSession}) => {
    const [expanded, setExpanded] = useState(false);
    const [addingType, setAddingType] = useState(false);
    const [editingName, setEditingName] = useState(false);
    const [deletingType, setDeletingType] = useState(undefined);
    const [hasBeenOpen, setHasBeenOpen] = useState(false);
    const {id, name, types} = preset;

    const setName = newName => {
        setPreset({id, name: newName, types})
    }

    const setTypes = newTypes => {
        setPreset({id, name, types: newTypes})
    }

    const addType = (newType) => {
        setTypes([...types, newType]);
        setAddingType(undefined);
    }

    const confirmDelete = () => {
        setTypes(types.filter(ot => ot !== deletingType));
        setDeletingType(undefined);
    }

    useEffect(() => {
        if (expanded && !hasBeenOpen) {
            setHasBeenOpen(true);
        }
        if (hasBeenOpen && !expanded && preset?.types?.length === 0) {
            doDelete();
        }
    }, [expanded, preset, hasBeenOpen]);

    const modal = addingType ? (
        <AddModal
            heading="Ny fast øvelse:"
            close={() => setAddingType(false)}
            confirm={addType}
        />
    ) : deletingType !== undefined ?
        (
            <Modal close={() => setDeletingType(undefined)}>
                <p>Slette {deletingType}?</p>
                <div className="buttonGroup">
                    <button
                        className="rounded thing"
                        onClick={confirmDelete}
                    >
                        Ja, slett
                    </button>
                    <button
                        className="rounded thing"
                        onClick={() => setDeletingType(undefined)}
                    >
                        Nei
                    </button>
                </div>
            </Modal>
        ) : undefined;

    const header = editingName ? (
        <div className="editingHeader">
            <input
                type="text"
                value={name}
                onChange={e => setName(e.target.value)}
                onBlur={() => setEditingName(false)}
            />
        </div>
    ) : (
        <div className="header">
            {
                expanded ? <button
                    onClick={() => setEditingName(true)}
                    className="editButton"
                >
                    <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px"
                         fill="#e8eaed">
                        <path
                            d="M200-200h57l391-391-57-57-391 391v57Zm-80 80v-170l528-527q12-11 26.5-17t30.5-6q16 0 31 6t26 18l55 56q12 11 17.5 26t5.5 30q0 16-5.5 30.5T817-647L290-120H120Zm640-584-56-56 56 56Zm-141 85-28-29 57 57-29-28Z"/>
                    </svg>
                </button> : <div className="placeHodler"/>
            }
            <h2
                onClick={() => setExpanded(pv => !pv)}
            >{name}</h2>
            <button
                onClick={() => {
                    addSession(preset)
                }}
            >
                <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px"
                     fill="#e8eaed">
                    <path
                        d="m380-300 280-180-280-180v360ZM480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z"/>
                </svg>
            </button>
        </div>
    )

    const map = {};
    const getId = (key) => {
        if (!map[key]) map[key] = 0;
        map[key] = map[key] + 1;
        return `${id}${map[key]}${key}`
    }

    const typeObjects = types.map(key => ({
        id: getId(key),
        label: key
    }))

    return (
        <div
            className={`preset ${expanded ? 'expanded' : ''}`}
        >
            {modal}
            {header}
            {
                expanded && (
                    <>
                        <SortableList
                            droppableId={preset.id}
                            items={typeObjects}
                            getId={(t) => t.id}
                            renderItem={t => {
                                return (
                                    <div
                                        key={t.id}
                                        className="rounded thing"
                                        onClick={() => setDeletingType(t.label)}
                                    >
                                        {t.label}
                                    </div>
                                )
                            }}
                        />
                        <AddButton onClick={() => setAddingType(true)}/>
                    </>
                )
            }

        </div>
    );
}